import React from 'react'

export default function NoDataPattern() {
  return (
    <pattern id='noDataPattern' width='4' height='8' patternUnits='userSpaceOnUse' patternTransform='rotate(45)'>
      <rect width='1' height='8' fill='#E2E0E0' />
    </pattern>
  )
}
